export const devExternalKeys = {
    recaptchaSiteKey: "6LcmW4EUAAAAAEzMqFX4wERHa806sgYZ2q2JiDyK"
  };
  
  export const prodExternalKeys = {
    recaptchaSiteKey: "6LcmW4EUAAAAAEzMqFX4wERHa806sgYZ2q2JiDyK"
  };